import { render } from "./SupervisorCpdTokensTab.vue?vue&type=template&id=082ade26"
import script from "./SupervisorCpdTokensTab.vue?vue&type=script&lang=js"
export * from "./SupervisorCpdTokensTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__